import { useState } from "react";
import { useNavigate } from "react-router-dom";

const quickTags = ["图书馆占座", "宿舍公约", "保研名单", "表白墙", "食堂新品", "校招时间线"];

const heroStats = [
  { value: "1280+", label: "已收录高校" },
  { value: "3400+", label: "每日新增帖子" },
  { value: "96", label: "活跃讨论区" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const go = (value: string) => {
    const q = value.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : "/topics");
  };

  return (
    <section className="relative w-full overflow-hidden" aria-label="高校吃瓜网首屏">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20a%20crowded%20university%20campus%20plaza%20with%20students%20talking%20in%20speech%20bubbles%2C%20warm%20coral%20terracotta%20amber%20and%20lime%20color%20palette%2C%20bold%20minimal%20geometric%20shapes%2C%20flat%20editorial%20poster%20style%2C%20high%20contrast%20dark%20lower%20area&width=1600&height=900&seq=campus-hero-2026&orientation=landscape"
          alt="高校吃瓜网首屏插画：校园广场上学生们讨论热门话题"
          title="高校吃瓜网 - 高校吃瓜论坛与社区"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative mx-auto w-full px-4 pb-16 pt-20 md:px-8 md:pb-24 md:pt-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3.5 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm md:text-sm">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-live-line animate-pulse-soft"></i>
            </span>
            每日精选 20 个高赞话题 · 讨论区全天更新
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
            <span className="mb-2 block font-heading text-base font-bold tracking-[0.3em] text-secondary-300 md:text-lg">
              高校吃瓜网
            </span>
            学生都在聊什么
            <br />
            一网打尽
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            热门帖子、讨论区、吃瓜群动态持续更新。输入你的学校或感兴趣的话题，几秒钟直达同校吃瓜现场，不错过任何一个角落。
          </p>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              go(keyword);
            }}
            className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row"
            role="search"
          >
            <div className="flex h-12 flex-1 items-center gap-2.5 rounded-full bg-background-50 px-5">
              <i className="ri-search-line text-lg text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索学校、话题或关键词…"
                aria-label="搜索学校、话题或关键词"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none md:text-[15px]"
              />
            </div>
            <button
              type="submit"
              className="flex h-12 cursor-pointer items-center justify-center gap-2 rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap md:text-[15px]"
            >
              <i className="ri-compass-3-line text-lg"></i>
              进入讨论区
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-2.5">
            <span className="text-xs text-background-200 md:text-sm">热搜：</span>
            {quickTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => go(tag)}
                className="cursor-pointer rounded-full border border-background-50/30 px-3 py-1.5 text-xs text-background-100 transition-colors hover:border-secondary-300 hover:text-secondary-300 md:text-sm"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <dl className="mt-14 flex flex-wrap gap-x-12 gap-y-6 md:mt-20">
          {heroStats.map((item) => (
            <div key={item.label}>
              <dt className="text-xs text-background-200 md:text-sm">{item.label}</dt>
              <dd className="font-heading text-2xl font-black text-background-50 md:text-3xl">
                {item.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}